<template>
  <p>当前位置:
    <span>首页</span>
    >
    <!-- <span>
      <slot name="fatherPath"></slot>
    </span>
    > -->
    <span class="currentTab">
      <slot name="sonPath"></slot>
    </span>
  </p>
</template>
<script>
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean
  }
}
</script>
<style lang="stylus" scoped>
.currentTab
  color globalFontColor
</style>
